module.exports = __webpack_public_path__ + "static/penn-mobile-home-0fa5efa7b51fb225e9d7be682aa612e8.svg";